exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll-to-top[data-v-b81f6050] {\n  position: fixed;\n  bottom: 30px;\n  right: 30px;\n}\nh1[data-v-b81f6050] {\n  font-size: 2em;\n}\n.office-container[data-v-b81f6050] {\n  padding: 25px;\n  max-width: 1024px;\n  margin: auto;\n}\n", ""]);

// exports
